import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Image from "./image";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    height: auto;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    max-width: 50%;
  }
`;

export default function BrandLogoImage({ image }) {
  const isSvg = image?.mimeType === "image/svg+xml";

  if (isSvg) {
    return (
      <Wrapper>
        <img
          src={image?.localFile?.publicURL || image?.sourceUrl}
          alt={image?.altText || ""}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Image image={image} />
    </Wrapper>
  );
}

BrandLogoImage.propTypes = {
  image: PropTypes.object,
};
